import { gql } from '@apollo/client';

const PROGRAM_FIELDS = gql`
  fragment programFields on Program {
    id
    title
    tenantId
    description
    durationInWeeks
    totalPriceInCents
    deliveryFeePerWeekInCents
    crossedOutPriceInCents
    stripePriceId
    extraConfig
    programMetros {
      metroId
      deliveries {
        day
      }
    }
  }
`;

export const GET_PROGRAMS = gql`
  query programs($input: ProgramsInput!) {
    programs(input: $input) {
      ...programFields
    }
  }
  ${PROGRAM_FIELDS}
`;

export const VALIDATE_ADDRESS_FOR_PROGRAM = gql`
  query validateAddressForProgram(
    $programId: Int!
    $address: ProgramAddressInput!
  ) {
    validateAddressForProgram(programId: $programId, address: $address) {
      ...programFields
    }
  }
  ${PROGRAM_FIELDS}
`;

export const GET_PROGRAM_CART_BLUEPRINTS = gql`
  query programCartBlueprints(
    $input: ProgramsInput!
    $deliveryWeek: Date!
    $metroId: Int!
  ) {
    programs(input: $input) {
      durationInWeeks
      programMetros(metroId: $metroId) {
        metroId
        deliveries {
          day
        }
        cartBlueprints(deliveryWeek: $deliveryWeek, metroId: $metroId) {
          deliveryWeek
          deliveries {
            deliveryDate
            lineItems {
              quantity
              variant {
                product {
                  gardenMealId
                  title
                  subtitle
                  imageUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;
